import { Col, Container, Row } from "react-bootstrap";
import Head from "next/head";
import { getSession } from "next-auth/react";

import styles from "../styles/Home.module.css";
import InnerLayout from "../components/InnerPageLayout";
import RaqMultiStep from "../components/RaqMultiStep";
import { authHeader } from "../_helpers";
import { Link } from "@material-ui/core";
import ProductSearch from "../components/ProductSearch";
import Videos from "../components/Videos";
import TestimonialSlider from "../components/TestimonialSlider";

function RequestQuote({ deviceType, states, categories, user, testimonials }) {
  return (
    <>
      <Head>
        <title>
          Request A Price - Budli.in - sell your used gadgets online in India
        </title>
        <meta
          name="description"
          content={`Request a price quote at Budli.in – ReCommerce Portal in India. 
              Just fill up the form and we will get back to you. Call us +91 ${process.env.NEXT_PUBLIC_CONTACT_NO} for details.`}
        />
        <meta
          name="Keywords"
          content="sell second hand mobile phone, sell mobile, sell old mobile, used laptop, 
              Online ReCommerce portal, sell mobile online, online ReCommerce portal India, 
              sell used mobile, sell used mobile phone, sell mobile phones, sell used tablet, 
              sell ipod, sell tab, sell used iphone, sell used ipad, sell used laptop, sell macbook, 
              sell old laptop"
        />
        <link rel="canonical" href="/request-a-quote" />
      </Head>
      <InnerLayout innerPage={true} deviceType={deviceType}>
      <section className="srchbarsec">
          <div className="py-md-5 py-4" style={{ backgroundColor: '#0474B4' }}>
            <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-10 col-lg-6">
                      <ProductSearch />
                  </div>
                </div>
            </div>
          </div> 
          <div className="pt-3">
              <div className="container">
                  <h1 className="mb-1 text-dark fw-600">Request A Price</h1>
                  <div className="d-flex align-items-center gap-1 breadcumb text-default-red">
                      <Link href="/">
                          <a className="text-default-red">Home</a>
                      </Link>
                      <span>/</span>
                      <span>Request A Price</span>
                  </div>
              </div>
          </div>
        </section>
        <section className="py-4">
          <div className="container">
            <RaqMultiStep stateList={states} mainCategories={categories} user={user}/>
          </div>
        </section>
        <section className="py-4 testisec">
            <div className="container"> 
              <div className="position-relative">
                <div className="testititsec text-center text-lg-left w-100">
                  <h2 className="mb-md-3 mb-2 h4 fw-600">What Our Users Say</h2>
                  <div className="text-dark mb-md-3 mb-2 testisubtit">Join our <strong className="text-default">600,000+ satisfied customers</strong>. Discover why they trust Budli for their tech needs</div>
                </div>
              </div>
              <TestimonialSlider slideperpage="2" testimonials={testimonials} />
            </div>
        </section>
        <section className="py-4 bg-light videosec mb-4">
            <div className="container">
              <div className="position-relative">
                <div className="videosecinr text-center text-lg-left w-100">
                  <h2 className="mb-2 h4 fw-600">Media & Customer Insights</h2>
                </div>
              </div>
              <Videos/>
            </div>
        </section>
      </InnerLayout>
    </>
  );
}

// This function gets called at build time
export async function getServerSideProps(context) {

  const testiapiUrl = `${process.env.NEXT_PUBLIC_API_URL}testimonials/allTestimonials/X-API-KEY/${process.env.NEXT_PUBLIC_API_KEY}/type/text/limit/10`;
  const testires = await fetch(testiapiUrl);
  const testimonials = await testires.json();



  const session = await getSession(context);
  // Detect device type in server side
  const UA = context.req.headers["user-agent"];
  const isMobile = Boolean(
    UA.match(/Android|BlackBerry|iPhone|Opera Mini|IEMobile|WPDesktop/i)
  );

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const apiUrl = `${process.env.NEXT_PUBLIC_API_URL}locations/stateList`;

  // Fetch data from external API
  const res = await fetch(apiUrl, requestOptions);
  if (!res.ok) {
    return {
      redirect: {
        permanent: false,
        destination: "/sell",
      },
    };
  }
  const states = await res.json();

  const categoryApiUrl = `${process.env.NEXT_PUBLIC_API_URL}categories/mainCategories`;

  // Fetch data from external API
  const catRes = await fetch(categoryApiUrl, requestOptions);
  if (!catRes.ok) {
    return {
      redirect: {
        permanent: false,
        destination: "/sell",
      },
    };
  }
  const categories = await catRes.json();
  // Pass data to the page via props
  return {
    props: {
      deviceType: isMobile ? "mobile" : "desktop",
      user: session ? session.user : null,
      states,
      categories,
      testimonials,
    },
  };
}

export default RequestQuote;
